const navbar = {
  packages: "Mga Pakete", // translated 
  hotelPackages: "Mga Pakete ng Hotel", // translated 
  experiences: "Mga Karanasan", // translated 
  close: "Isara", // translated 
  hotDeals: "Mga Maiinit na Alok", // translated 
  dashboard: "Dashboard", // translated 
  pricing: "Pagpepresyo", // translated 
};


export default navbar;
